export enum Roles {
  underwriter = "underwriter",
  loanOfficer = "loan_officer",
  loanProcessor = "loan_processor",
  creditCommittee = "credit_committee",
  // Test-environment counterparts of the roles above (same "test_" convention
  // as test_loan_officer) — must behave identically to the real roles.
  testUnderwriter = "test_underwriter",
  testCreditCommittee = "test_credit_committee",
  // Waiver authorization is permission-based rather than job-role-based:
  // any user whose token carries these, regardless of job role, can
  // request / approve-reject-conditionally-approve a waiver.
  requestWaiver = "request_waiver",
  approveWaiver = "approve_waiver",
  // Same permission-based model as above, for the Loan Economics pricing
  // fields (Interest Rate / Final Toorak Price): any user whose token
  // carries this, regardless of job role, can view and edit them.
  updatePricing = "update_pricing",
  // Gates the "Pricing" adjustments breakdown card (bplsizer shows it
  // unconditionally today; merchants shows it only with this permission —
  // see LeveragePricing.ts's buildDscrTab0). update_pricing_adjustment
  // additionally gates per-row editing of that same card.
  showPricingAdjustment = "show_pricing_adjustment",
  updatePricingAdjustment = "update_pricing_adjustment",
  capitalMarket = "capital_market"
}

export enum EscalationTarget {
  processor = "processor",
  underwriter = "underwriter",
  creditCommittee = "creditCommittee",
  // Only credit_committee can escalate to this target (see Header.tsx's
  // getEscalationTargets) — Capital Markets pricing (Roles.updatePricing)
  // has no job-role of its own, but the escalation banner still needs a
  // distinct target label for "the loan is now waiting on Capital Markets."
  capitalMarket = "capitalMarket"
}
